import { DirectiveOptions } from 'vue';

const triggerPopover: DirectiveOptions = {
    bind(el, binding) {
        $(el).popover();
    }
};

export default triggerPopover;